export default __webpack_public_path__ + "static/media/money-receipt-template-2.d5cfdd3a.png";